import React from 'react';
import { Modal } from 'library/ui';
import { AddPaymentMethod } from './AddPaymentMethod';
import { PaymentMethod } from './types';

type SupportedKind = 'card' | 'bank';

interface AddPaymentMethodModalProps {
    open: boolean;
    onClose: () => void;
    onSuccess?: (method: PaymentMethod) => void;
    allowedKinds?: SupportedKind[];
    title?: string;
}

export function AddPaymentMethodModal({
    open,
    onClose,
    onSuccess,
    allowedKinds = ['card', 'bank'],
    title = 'Add Payment Method',
}: AddPaymentMethodModalProps) {
    if (!open) return null;
    return (
        <Modal title={title} onClose={onClose} width={520}>
            <AddPaymentMethod
                allowedKinds={allowedKinds}
                onSuccess={(method) => {
                    onSuccess?.(method);
                    onClose();
                }}
                onCancel={onClose}
            />
        </Modal>
    );
}
